import { action } from 'easy-peasy';
import { IActionRemoveProgram } from '../types';

const removeProgram: IActionRemoveProgram = action((state, id) => {
  state.items = state.items.filter(item => item.id !== id);
});

export default removeProgram;
